import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import {
  initializeFeatureSelectionForPrinting,
  initializePromotion,
  initializeSectionsForPrinting, updateTotalPrice,
} from '../../model/configuratorSlice';
import SummarySectionsListPrinting from './SummarySectionsListPrinting';
import { ClientId } from '../../model/constants';
import LoadConfigurationService from '../../services/LoadConfigurationService';
import { FeatureSelectionUtility } from '../../utilities/FeatureSelectionUtility';
import BudgetStatus from './Component/BudgetStatus';


const SummaryPanelPrinting = () => {
  const { code } = useParams();
  const promotionId = 3135;
  // const code = 'afasdfsd';
  const {
   settings, categories, isLoading, printingShots,
  } = useSelector(state => state.configurator);

  const loadConfigurationMutation = LoadConfigurationService();

  const [firstShot, setFirstShot] = useState(null);
  const [secondShot, setSecondShot] = useState(null);
  const [thirdShot, setThirdShot] = useState(null);
  const [fourthShot, setFourthShot] = useState(null);
  const [fifthShot, setFifthShot] = useState(null);
  const dispatch = useDispatch();

  /*
  function useQueryParams() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  const query = useQueryParams();

  let jsonUrl = `https://configurator.bizionar.digital/${ClientId}/${promotionId}/`;
  if (code !== undefined) {
    jsonUrl += `code/${promotionId}_${code}.json`;
  } else {
    jsonUrl += `live/json/${promotionId}.json`;
  }

  const linkUrl = `https://${ClientId}.bizionar.digital/${promotionId}/${code}`; */

  useEffect(() => {
    loadConfigurationMutation.mutate({});
  }, []);

  useEffect(() => {
    if (!isLoading) {
      dispatch(initializeFeatureSelectionForPrinting(code));
      dispatch(initializeSectionsForPrinting());
      dispatch(updateTotalPrice());
    }
  }, [isLoading]);

  useEffect(() => {
    if (printingShots !== null) {
      setFirstShot(printingShots[3]);
      setSecondShot(printingShots[0]);
      setThirdShot(printingShots[2]);
      setFourthShot(printingShots[4]);
      setFifthShot(printingShots[1]);
    }
  }, [printingShots]);

  /* const {
    isLoading,
    error,
  } = useQuery(
    ['configurator'],
    () => fetch(jsonUrl)
      .then(res => res.json())
      .then((data) => {
        dispatch(initializePromotion(data));
        dispatch(initializeSectionsForPrinting());
      }),
  ); */

  if (isLoading) return 'Loading...';

  // if (error) return `An error has occurred: ${error.message}`;

  document.body.style.overflowY = 'visible';
  document.body.style.backgroundColor = 'white';

  return (
    <div className="summary-panel-printing">
      <div className="summary-content">
        <div className="top-images-container">
          <div className="image-printing-summary">
            <img src={`${settings.shots_base_url}/${firstShot}.jpg`} alt="" />
          </div>
          <div className="image-printing-summary large">
            <img src={`${settings.shots_base_url}/${secondShot}.jpg`} alt="" />
          </div>
        </div>
        <div className="middle-images-container">
          <div className="image-printing-summary large">
            <img src={`${settings.shots_base_url}/${thirdShot}.jpg`} alt="" />
          </div>
          <div className="client-promotion-square-summary">
            <div className="client-logo">
              <img
                src={`${process.env.PUBLIC_URL}/metrovacesa_pdf.png`}
                alt=""
              />
            </div>
            <div className="client-promotion-container">
              {/* <div className="client">
                <img
                  src={`${process.env.PUBLIC_URL}/img/habitat_summary_square.png`}
                  alt=""
                />
              </div> */}
              <div className="promotion">{settings.name}</div>
            </div>
          </div>
        </div>
        <div className="bottom-images-container">
          <div className="image-printing-summary">
            <img src={`${settings.shots_base_url}/${fourthShot}.jpg`} alt="" />
          </div>
          <div className="image-printing-summary large">
            <img src={`${settings.shots_base_url}/${fifthShot}.jpg`} alt="" />
          </div>
        </div>
        <div className="data-container">
          <div className="user-data">
            <div className="title">Datos</div>
            <div className="date">Fecha: <span>{new Date(Date.now()).toLocaleString().split(',')[0]}</span></div>
            <div className="flat">Vivienda: <span>-</span></div>
            <div className="typology">Tipología: <span>-</span></div>
            {/* <div className="date">Nº Formalización: <span>-</span></div> */}
            <div className="divider" />
          </div>
          <div className="configuration-data">
            <div className="title" />
            {/* eslint-disable-next-line max-len */}
            <div className="subtitle" />
            <div className="container-qr-text">
              <div className="code-title"><span /></div>
              <div className="code" />
              <div className="link">
                {/* <a href={linkUrl}>
                  <span>{linkUrl}</span>
                </a> */}
              </div>
            </div>
          </div>
        </div>
        <div className="bottom-line-container">
          <BudgetStatus isRequestBudget={false} includesPrices={false} />
        </div>
        <div className="legal-base-text" />
        <div className="sections-list-container">
          {/* <SummarySectionsListPrinting login={query.get('login') === 'true'} /> */}
          <SummarySectionsListPrinting login />
        </div>
      </div>
    </div>
  );
};

export default SummaryPanelPrinting;
